module.exports = __webpack_public_path__ + "static/media/affiliate-program.3ad194ca.webp";